/* The Scouted Stitch — Visual Print Selector + Two-Way Image Sync
   Only activates on product pages whose print option has multiple values,
   each with its own image. Safe to load site-wide. */
(function () {
  'use strict';
  var PRINT_OPTION_NAMES = ['color', 'print', 'pattern', 'fabric'];
  var MIN_VALUES = 3;

  function ready(fn){ document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn); }

  ready(function () {
    var handle = (location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1];
    if (!handle) return;
    fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }).then(build).catch(function(){});
  });

  function build(p) {
    var idx = -1;
    p.options.forEach(function (o, i) {
      var name = (typeof o === 'string' ? o : o.name || '').toLowerCase();
      if (PRINT_OPTION_NAMES.indexOf(name) !== -1) idx = i;
    });
    if (idx === -1) return;
    var values = (p.options[idx].values) || [];
    if (values.length < MIN_VALUES) return;

    var colorToVar = {}, mediaToColor = {}, hasImages = 0;
    p.variants.forEach(function (v) {
      var c = v.options[idx];
      if (!colorToVar[c]) colorToVar[c] = v;
      if (v.featured_media) { mediaToColor[v.featured_media.id] = c; hasImages++; }
    });
    if (!hasImages) return; // no per-print images -> leave the dropdown alone

    var nativeSel = document.getElementById('SingleOptionSelector-' + idx);
    var ymqSel = document.getElementById('ymq-attrib-ymq-variant-' + idx) ||
                 document.querySelector('select[name="ymq-option' + (idx + 1) + '"]');

    var strip = document.createElement('div');
    strip.className = 'tss-print-swatches';
    strip.innerHTML = '<div class="tss-print-head">Print <span class="tss-print-current"></span></div>' +
                      '<div class="tss-print-grid"></div>';
    var grid = strip.querySelector('.tss-print-grid');
    var currentEl = strip.querySelector('.tss-print-current');

    values.forEach(function (c) {
      var v = colorToVar[c];
      var src = v && v.featured_image && v.featured_image.src;
      var thumb = src ? src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'tss-print-sw';
      b.setAttribute('data-print', c);
      b.setAttribute('aria-label', c);
      b.title = c;
      b.innerHTML = thumb ? '<img src="' + thumb + '" alt="' + c + '" loading="lazy">' : '<span>' + c + '</span>';
      b.addEventListener('click', function () { select(c, true); });
      grid.appendChild(b);
    });

    var anchor = (ymqSel && (ymqSel.closest('.ymq-options-box') || ymqSel.closest('.ymq-box'))) ||
                 (nativeSel && nativeSel.closest('.selector-wrapper')) ||
                 document.querySelector('form[action*="/cart/add"]');
    anchor.parentNode.insertBefore(strip, anchor);
        var descEl = document.querySelector('.product-single__description');
    if (descEl) strip.parentNode.insertBefore(descEl, strip);
    if (ymqSel) { var yb = ymqSel.closest('.ymq-options-box'); if (yb) yb.style.display = 'none'; }
    if (nativeSel) { var nw = nativeSel.closest('.selector-wrapper'); if (nw) nw.style.display = 'none'; }

    function highlight(c) {
      currentEl.textContent = c;
      Array.prototype.forEach.call(grid.children, function (s) {
        s.classList.toggle('is-selected', s.getAttribute('data-print') === c);
      });
    }
    // user click: change the print (updates photo + variant via the real selectors)
    function select(c, user) {
      highlight(c);
      if (nativeSel) { nativeSel.value = c; if (user) nativeSel.dispatchEvent(new Event('change', { bubbles: true })); }
      if (ymqSel)    { ymqSel.value = c;    if (user) ymqSel.dispatchEvent(new Event('change', { bubbles: true })); }
    }

    // reverse sync: browsing photos updates the selected print (no re-dispatch = no loop)
    var wraps = Array.prototype.slice.call(document.querySelectorAll('.product-single__media-wrapper'));
    if (wraps.length) {
      var obs = new MutationObserver(function () {
        var vis = wraps.filter(function (w) { return !w.classList.contains('hide') && w.offsetParent !== null; })[0];
        if (!vis) return;
        var mid = parseInt((vis.getAttribute('data-media-id') || '').split('-').pop(), 10);
        var c = mediaToColor[mid];
        if (c && currentEl.textContent !== c) select(c, true);
      });
      wraps.forEach(function (w) { obs.observe(w, { attributes: true, attributeFilter: ['class'] }); });
    }

    highlight(values[0]);
  }
})();